import { Button, Modal } from "@design";
import { useTranslation } from "react-i18next";
import type { OAuthClientCreated } from "@/api";
import { CopyValue } from "@/components/CopyValue";
import { Text } from "@/components/Text";

/** Shows a confidential client's secret, exactly once, right after creation. */
export function OAuthClientSecretModal({
  created,
  onClose,
}: Readonly<{ created: OAuthClientCreated | null; onClose: () => void }>) {
  const { t } = useTranslation("adminPlatform");
  const secret = created?.clientSecret;
  return (
    <Modal
      open={Boolean(secret)}
      onClose={onClose}
      title={t("oauthClients.secret.title")}
      actions={
        <Button variant="primary" onClick={onClose}>
          {t("oauthClients.secret.done")}
        </Button>
      }
    >
      {created && secret && (
        <div className="flex flex-col gap-3">
          <Text variant="body-sm" tone="warning">
            {t("oauthClients.secret.body")}
          </Text>
          <div className="flex flex-col gap-1">
            <Text variant="caption" tone="tertiary">
              {t("oauthClients.secret.clientId")}
            </Text>
            <CopyValue value={created.client.clientId} label={t("oauthClients.secret.clientId")} />
          </div>
          <div className="flex flex-col gap-1">
            <Text variant="caption" tone="tertiary">
              {t("oauthClients.secret.secret")}
            </Text>
            <CopyValue value={secret} label={t("oauthClients.secret.secret")} secret />
          </div>
        </div>
      )}
    </Modal>
  );
}
